import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
var _excluded = ["onStateChange"];
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useRef, useState, useCallback, useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import { Cache } from '../../utils/cache';
var FIVE_MINUTES = 300000;
var cache = new Cache({
  defaultTtl: FIVE_MINUTES
});
export function useValueList(_ref) {
  var _ref$ttl = _ref.ttl,
      ttl = _ref$ttl === void 0 ? FIVE_MINUTES : _ref$ttl,
      cacheKey = _ref.cacheKey,
      getItems = _ref.getItems;
  var id = useRef(cacheKey !== null && cacheKey !== void 0 ? cacheKey : null);

  if (id.current === null) {
    id.current = uuid();
  }

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      helperText = _useState8[0],
      setHelperText = _useState8[1]; // We need this ref so that we can use it within the
  // useEffect callback and have it function as intended


  var isOpenRef = useRef(isOpen);
  isOpenRef.current = isOpen;

  var _onStateChange = useCallback(function (changes) {
    var isOpen = changes.isOpen; // Synchronise the isOpen state from the select

    if (changes.hasOwnProperty('isOpen')) {
      setIsOpen(isOpen);
    }
  }, []);

  var getSelectProps = useCallback(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var passedOnStateChange = _ref2.onStateChange,
        args = _objectWithoutProperties(_ref2, _excluded);

    return _objectSpread(_objectSpread({}, args), {}, {
      helperText: helperText,
      items: items,
      onStateChange: function onStateChange(changes) {
        _onStateChange(changes);

        passedOnStateChange === null || passedOnStateChange === void 0 ? void 0 : passedOnStateChange(changes);
      }
    });
  }, [helperText, items, _onStateChange]);
  useEffect(function () {
    if (!isOpen) {
      return;
    }

    var controller = new AbortController();
    var signal = controller.signal;

    function resolveItems() {
      return _resolveItems.apply(this, arguments);
    }

    function _resolveItems() {
      _resolveItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var items;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setItems([]);
                setIsLoading(true);
                _context.next = 4;
                return _Promise.resolve(getItems({
                  signal: signal
                }));

              case 4:
                items = _context.sent;

                if (!signal.aborted) {
                  cache.put(id.current, items, {
                    ttl: ttl
                  });
                  setItems(items);
                  setIsLoading(false);
                }

                return _context.abrupt("return", items);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _resolveItems.apply(this, arguments);
    }

    var cachedItems = cache.get(id.current); // If there are no items in the cache then re-fetch

    if (!cachedItems) {
      resolveItems();
    } else {
      setItems(cachedItems);
    }

    return function () {
      setIsLoading(false);
      controller.abort(); // This stops the items from disappearing as
      // the menu closes (which looks kinda weird)

      if (isOpenRef.current) {
        setItems([]);
      }
    };
  }, [ttl, isOpen, getItems]);
  useEffect(function () {
    if (isLoading) {
      return setHelperText('Loading...');
    }

    setHelperText(null);
  }, [isLoading, items]);
  return {
    getSelectProps: getSelectProps
  };
}